export default "__VITE_ASSET__9e2280d0__"